import { CUSTOM_PATH_SOURCE } from './constants';
import { safeSetSourceData } from './utils';
import { debug } from '../../../utils/debug';

// Convert path data to GeoJSON format for map rendering
const pathToGeoJSON = (path, locations) => {
  if (!path || path.length === 0) {
    return { type: 'FeatureCollection', features: [] };
  }

  if (path.vehiclePaths) {
    // Handle multiple vehicle paths
    return { 
      type: 'FeatureCollection', 
      features: path.vehiclePaths.map(vehicle => ({
        type: 'Feature',
        properties: { 
          color: vehicle.color || '#ff7f0e',
          vehicleId: vehicle.vehicle_id 
        },
        geometry: {
          type: 'LineString',
          coordinates: vehicle.path.map(point => [point.lng, point.lat])
        }
      }))
    };
  } else {
    // Handle single path
    const coordinates = path
      .map(id => locations.find(loc => loc.id === id))
      .filter(Boolean)
      .map(loc => [loc.longitude, loc.latitude]);
      
    return {
      type: 'FeatureCollection',
      features: [{
        type: 'Feature',
        properties: { color: '#ff7f0e' },
        geometry: { type: 'LineString', coordinates }
      }]
    };
  }
};

// Update the custom path display on the map
export const updateCustomPath = ({
  map,
  mapReady,
  sourcesReady,
  customPath,
  locations,
  shouldShowCustomPath
}) => {
  debug('CUSTOM-PATH', 'Updating custom path', { 
    pathLength: Array.isArray(customPath) ? customPath.length : 0,
    hasVehiclePaths: Boolean(customPath?.vehiclePaths)
  });

  if (!map || !mapReady || !sourcesReady) {
    debug('CUSTOM-PATH', 'Map not ready');
    return;
  }

  if (!shouldShowCustomPath || !customPath || customPath.length === 0) {
    safeSetSourceData(map, mapReady, sourcesReady, CUSTOM_PATH_SOURCE, { type: 'FeatureCollection', features: [] });
    return;
  }

  try {
    const pathData = pathToGeoJSON(customPath, locations);
    safeSetSourceData(map, mapReady, sourcesReady, CUSTOM_PATH_SOURCE, pathData);
    debug('CUSTOM-PATH', 'Path updated successfully');
  } catch (error) {
    debug('CUSTOM-PATH', 'Error updating path', error);
  }
};